import "../App.css";
import React from 'react'
import repo from "../Images/repo.png";

const Project = ({imgSource,title,description,gitLink}) => {
  return (
    <div className='projectCard'>
        <img src={imgSource} alt="image"/>
        <h2>{title}</h2>
        <p>{description}</p>
        <a className="repoBtn" href={gitLink} target="_blank"><img className="repoImg" src={repo}/><h3>Github Link</h3></a>
    </div>
  )
}

export default Project